(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
// Go to corresponding slide on Shopify's editor
document.addEventListener('shopify:block:select', (e) => {
    const carouselEl = e.target.closest('.carousel')

    if (carouselEl) {
        const selectedSlide = e.target.dataset.index
        bootstrap.Carousel.getOrCreateInstance(carouselEl, { interval: false }).to(selectedSlide)
    }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coll-carousel"] && !Shopify.designMode) return;
  try {
    
// this fixes selection issue when hitting next on a carousel then switching tabs
let carouselButtons = document.querySelectorAll('.collections-carousel ul.nav button');
carouselButtons.forEach(button => {
    button.addEventListener('click', function handleClick(event) {
        clearSelection();
    });
});

// this sets up multiple swipers and properly attaches next/prev buttons
const swipersContainer = document.querySelectorAll(
    ".collections-carousel .swiper-container"
);

if (swipersContainer.length > 0) {
    swipersContainer.forEach(function (element, index) {
        let swiperEl = element.querySelector(".swiper");

        new Swiper(swiperEl, {
            // Optional parameters
            direction: "horizontal",
            loop: false,
            autoplay: false,
            slidesPerView: 3,

            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                // when window width is >= 480px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                // when window width is >= 640px
                992: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
                // when window width is >= 1680px
                1680: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
            },

            // Navigation arrows
            navigation: {
                nextEl: element.querySelector(".swiper-button-next"),
                prevEl: element.querySelector(".swiper-button-prev")
            },
        });
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dual-carousel"] && !Shopify.designMode) return;
  try {
    
  // Go to corresponding slide on Shopify's editor
  document.addEventListener('shopify:block:select', (e) => {
    const carouselEl = e.target.closest('.carousel');

    if (carouselEl) {
      const selectedSlide = e.target.dataset.index;
      bootstrap.Carousel.getOrCreateInstance(carouselEl, { interval: false }).to(selectedSlide);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
